<template>
	<div>
		<img  class="imgtop" src="http://shandongtibohui.zsyflive.com/profile/xd/ruier/gongzhong/20201223110319a77bae.jpg"/>
		<div class="colonn" style="width: 70vw;margin-left: 15vw;">
			<div class="roww center_center">
				<div class="colonn "
				 
				 :class="{
				 	'topmenuviewtxt1':typeIndex==0,
				 	'topmenuviewtxt':typeIndex!=0,
				 }" 
				 
				 @click.stop="typeClick(0)">
					<div>展会企业特装</div>
				</div>
				<div class="colonn  "
				 
				 :class="{
				 	'topmenuviewtxt1':typeIndex==1,
				 	'topmenuviewtxt':typeIndex!=1,
				 }" 
				  @click.stop="typeClick(1)">
					<div>文化主题馆</div>
				</div>
				<div class="colonn  "
				 
				 :class="{
				 	'topmenuviewtxt1':typeIndex==2,
				 	'topmenuviewtxt':typeIndex!=2,
				 }" 
				  @click.stop="typeClick(2)">
					<div>企业展厅</div>
				</div>
				
				<div class="colonn  "
				 :class="{
				 	'topmenuviewtxt1':typeIndex==3,
				 	'topmenuviewtxt':typeIndex!=3,
				 }" 
				  @click.stop="typeClick(3)">
					<div>轮胎展</div>
				</div>
				
				<div class="colonn  "
				 :class="{
				 	'topmenuviewtxt1':typeIndex==4,
				 	'topmenuviewtxt':typeIndex!=4,
				 }" 
				  @click.stop="typeClick(4)">
					<div>粮油展</div>
				</div>
				
				
			</div>
			<div style="height: 20px;"></div>
			<div class="huanhang ">
				<div v-for="(item,index) in listImg[typeIndex]" style="width: 33%;height: 300px;margin-right: 0.3%;  margin-bottom: 5px;position: relative;">
					<img  style="width: 100%;top: 0px;left: 0px;height: 300px;" class="poab" 
					:src="item.img" 
					/>
					<div style="width: 100%;bottom: 0px;left: 0px;height: 60px;background-color: rgba(0, 0,0, 0.5);text-align: center;line-height: 60px;color: white;" class="poab" >
						{{item.title}}
					</div>
				</div>
			</div>
			<div style="height: 20px;"></div>
		</div>
		
	</div>
</template>

<script>

	export default {
		name: 'ComponentName', // 组件的名称
		components: {
			
		},

		data() {
			return {
				listImg:[
					[
						{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/1.jpg',
							title:'项目名称：山东能源（1） 项目面积：120平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/2.jpg',
							title:'项目名称：山东能源（2） 项目面积：120平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/3.jpg',
							title:'项目名称：山东能源（3） 项目面积：120平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/4.jpg',
							title:'项目名称：山东能源（4） 项目面积：120平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/5.jpg',
							title:'展会名称：沂安消防（1）展会面积：72平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/6.jpg',
							title:'展会名称：沂安消防（2）展会面积：72平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/7.png',
							title:'展品名称：木都商品（1）展会面积：110平'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyetezhaung/8.png',
							title:'展会名称：木都尚品（2）展会面积：110平'
						}
					],
					
					[
						{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/1.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/2.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/3.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/4.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/5.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/6.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/7.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/8.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/zhutiwenhuaguan/9.jpg',
							title:'图片展示'
						},
					],
					
					[
						{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyezhanting/1.jpg',
							title:'36平（1）'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/qiyezhanting/2.jpg',
							title:'36平（1）'
						},
					],
					[
						{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/luntaizhan/1.jpg',
							title:'90平金旺达 (1) (大尺寸)'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/luntaizhan/3.jpg',
							title:'90平金旺达 (2) (大尺寸)'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/luntaizhan/2.jpg',
							title:'64平大连橡塑轮胎展 (1)'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/luntaizhan/4.jpg',
							title:'64平大连橡塑轮胎展 (2)'
						},
					]
					,
					[
						{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/liangyouzahn/1.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/liangyouzahn/2.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/liangyouzahn/3.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/liangyouzahn/4.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/liangyouzahn/5.jpg',
							title:'图片展示'
						},{
							'img':'http://shandongtibohui.zsyflive.com/profile/xd/ruier/liangyouzahn/6.jpg',
							title:'图片展示'
						},
					],
				],
				typeIndex:0
			}
		},

		props: {
			// 组件的属性
		},

		computed: {
			// 组件的计算属性
		},

		methods: {
				// 组件挂载后的操作
			typeClick(index){
				this.typeIndex=index;
			},
		},

		mounted() {
			
		},

	}
</script>

<style>
	@import url(anlizhanshi.css);
</style>